import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMapMarkerAlt, 
  faEnvelope, 
  faPhone,
  faClock
} from '@fortawesome/free-solid-svg-icons';
import './Contact.scss';

/**
 * Contact component for MET Connect® website
 * 
 * Provides company information and location details
 * for users to easily get in touch
 * 
 * @returns {JSX.Element} The Contact component
 */
const Contact = () => {
  /**
   * Contact details for MET Connect®
   */
  const contactDetails = [
    {
      icon: faMapMarkerAlt,
      title: 'Location',
      details: [
        'Australian Software Distribution Pty. Ltd.',
        '205/10 Albert Ave., BROADBEACH',
        'QLD 4218, Australia'
      ]
    },
    {
      icon: faEnvelope,
      title: 'Email Us',
      details: ['support@met-connect.com'],
      isEmail: true
    },
    {
      icon: faPhone,
      title: 'Call Us',
      details: ['+61 (0)7 3333 23 53']
    },
    {
      icon: faClock,
      title: 'Business Hours',
      details: ['Monday - Friday: 8am - 5pm', 'Saturday & Sunday: Closed']
    }
  ];
  
  return (
    <section className="contact-section" id="contact">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <h2 className="section-title">Get In Touch</h2>
            <p className="section-subtitle">
              Have questions about our services or need a customized solution? 
              Contact our team and we'll be happy to assist you.
            </p>
          </Col>
        </Row>
        
        <Row className="contact-cards">
          {contactDetails.map((item, index) => (
            <Col md={6} lg={3} key={index} className="mb-4">
              <Card className="contact-card h-100">
                <Card.Body className="text-center">
                  <div className="contact-icon">
                    <FontAwesomeIcon icon={item.icon} />
                  </div>
                  <h4 className="contact-title">{item.title}</h4>
                  <div className="contact-text">
                    {item.details.map((detail, idx) => (
                      <p key={idx}>
                        {item.isEmail ? (
                          <a href={`mailto:${detail}`} className="email-link">
                            {detail}
                          </a>
                        ) : (
                          detail
                        )}
                      </p>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Contact;